const menu_management_en = {
  edit_menu_info:'edit menu information',
  empty_menu_name:'Please enter menu name',
  empty_menu_code:'Please enter menu code',
  empty_parent_num:'Please select parent number',
  empty_req_addr:'Please enter the request address',
  empty_sys_type:'Please select system classification'
}

export default menu_management_en



// WEBPACK FOOTER //
// ./src/common/lang/menu_management/menu_management_en.js